import React, { useEffect, useState } from "react";
import SimulationApi from "../../api/SimulationApi";
import { EBooleanSensorType } from "../../Model/EBooleanSensorType";
import { ModuleBooleanSensorValue } from "../../Model/Simulation";
import CheckBox from "../Buttons/CheckBox";
import "./SimulationSensorToggler.css";

export default function SimulationSensorToggler() {
  const [moduleBooleanSensorValues, setModuleBooleanSensorValues] = useState([] as ModuleBooleanSensorValue[]);

  useEffect(() => {
    SimulationApi.readBooleanSensors("Suite").then((moduleBooleanSensorValues) => {
      setModuleBooleanSensorValues(moduleBooleanSensorValues);
    });
  }, []);

  const onChange = (index: number, moduleIdentifier: string, type: EBooleanSensorType) => {
    let newValue = [...moduleBooleanSensorValues];
    let value: ModuleBooleanSensorValue = {
      ...moduleBooleanSensorValues[index],
      value: !moduleBooleanSensorValues[index],
    };
    newValue[index] = value;
    setModuleBooleanSensorValues(newValue);

    SimulationApi.toggleBooleanSensor(moduleIdentifier, type).then(() => {
      SimulationApi.readBooleanSensors("Suite").then((moduleBooleanSensorValues) => {
        setModuleBooleanSensorValues(moduleBooleanSensorValues);
      });
    });
  };

  return (
    <div className="simulation-sensor-toggler-content">
      {moduleBooleanSensorValues.map((ssb, index) => (
        <CheckBox
          key={`simulation-toggler-sensor-${EBooleanSensorType[ssb.type]}`}
          style={{ margin: 10 }}
          id={index.toString()}
          label={EBooleanSensorType[ssb.type]}
          name={index.toString()}
          checked={ssb.value}
          disabled={false}
          onChange={(value) => onChange(index, ssb.moduleIdentifier, ssb.type)}
        />
      ))}
    </div>
  );
}
